import React from 'react';

export const IconSmallChartsLegacy: React.FC = (props = {}) => (
    <svg height="24" width="24" fill="none" viewBox="0 0 24 24" {...props}>
        {props.children}
        <path d="M20 5h-3v15h3V5zm-8 2H9v13h3V7zm-4 7H5v6h3v-6zm5-4h3v10h-3V10z" fill="#374050" fillRule="evenodd" />
    </svg>
);
